import { useTranslation } from 'react-i18next';

export default function Location() {
  const { t } = useTranslation();
  
  const openGoogleMaps = () => {
    window.open('https://www.google.com/maps/search/?api=1&query=Mola+Közde+Kahveci+Kadıköy', '_blank');
  };

  return (
    <section id="location" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-amber-600 font-semibold text-sm tracking-wider uppercase">{t('location.badge')}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            {t('location.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t('location.subtitle')}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-8">
            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-3xl p-8 shadow-lg">
              <div className="flex items-start space-x-4 mb-6">
                <div className="w-14 h-14 bg-amber-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-fill text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{t('location.addressTitle')}</h3>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {t('location.address')}
                  </p>
                </div>
              </div>
              <button
                onClick={openGoogleMaps}
                className="w-full px-6 py-3 bg-amber-600 text-white rounded-full hover:bg-amber-700 transition-colors font-semibold flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-navigation-fill text-xl"></i>
                <span>{t('location.getDirections')}</span>
              </button>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-3xl p-8 shadow-lg">
              <div className="flex items-start space-x-4 mb-6">
                <div className="w-14 h-14 bg-amber-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-fill text-2xl text-white"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{t('location.contactTitle')}</h3>
                  <p className="text-gray-600 text-lg">
                    0532 293 73 52
                  </p>
                </div>
              </div>
              <a
                href="tel:+905322937352"
                className="w-full px-6 py-3 bg-amber-600 text-white rounded-full hover:bg-amber-700 transition-colors font-semibold flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill text-xl"></i>
                <span>{t('location.callNow')}</span>
              </a>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-3xl p-8 shadow-lg">
              <div className="flex items-start space-x-4">
                <div className="w-14 h-14 bg-amber-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-car-fill text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{t('location.transportTitle')}</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start space-x-2">
                      <i className="ri-subway-fill text-amber-600 mt-1"></i>
                      <span>{t('location.transport1')}</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <i className="ri-bus-fill text-amber-600 mt-1"></i>
                      <span>{t('location.transport2')}</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <i className="ri-parking-box-fill text-amber-600 mt-1"></i>
                      <span>{t('location.transport3')}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:sticky lg:top-24">
            <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-amber-100">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3011.894765432109!2d29.021900315435!3d40.98770007930!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab9f6e6e6e6e7%3A0x1234567890abcdef!2zQ2FmZXJhxJ9hLCBNw7xow7xyZGFyIENkLiBObzoyNSwgMzQ3MTAgS2FkxLFrw7Z5L8Swc3RhbmJ1bA!5e0!3m2!1str!2str!4v1234567890123!5m2!1str!2str"
                width="100%"
                height="700"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Mola Közde Kahve Konumu"
              ></iframe>
            </div>
            <div className="mt-6 text-center">
              <button
                onClick={openGoogleMaps}
                className="inline-flex items-center space-x-2 px-8 py-4 bg-gradient-to-r from-amber-600 to-amber-700 text-white rounded-full hover:from-amber-700 hover:to-amber-800 transition-all duration-300 font-semibold shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-map-pin-2-fill text-2xl"></i>
                <span>{t('location.openInMaps')}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
